import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export const SvgMinus = () => (_jsx("svg", Object.assign({ viewBox: "0 0 30 30", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 14v2.5h22V14H4z" }, void 0) }), void 0));
//# sourceMappingURL=minus.js.map
